import type { z } from 'zod';
import { attachmentSchema } from '@/entities/shared/attachment/attachment';
import { categorySchema } from '@/entities/shared/category/category';
import { centsField } from '@/entities/shared/schemas/cents-field';
import { isoDateField } from '@/entities/shared/schemas/iso-date-field';
import { longTextField } from '@/entities/shared/schemas/long-text-field';
import { nameField } from '@/entities/shared/schemas/name-field';
import { shortTextField } from '@/entities/shared/schemas/short-text-field';
import { tagField } from '@/entities/shared/schemas/tag-field';
import { zs } from '@/entities/shared/schemas/zod';

/** Something we have: one row per product and place. Mirrors apps/api …/collections/item.py. */
export const itemSchema = zs.looseObject({
  name: nameField,
  category: categorySchema.default('other'),
  quantity: zs.number().min(0).default(1),
  unit: shortTextField.default('ud'),
  min_quantity: zs.number().min(0).optional(),
  location: shortTextField.optional(),
  brand: shortTextField.optional(),
  price_cents: centsField.optional(),
  store: shortTextField.optional(),
  url: zs.string().trim().max(2000).optional(),
  purchased_on: isoDateField.optional(),
  expires_on: isoDateField.optional(),
  best_before: isoDateField.optional(),
  replace_on: isoDateField.optional(),
  shelf_life_months: zs.number().int().min(1).max(1200).optional(),
  active_ingredient: shortTextField.optional(),
  dosage: shortTextField.optional(),
  tags: zs.array(tagField).default([]),
  notes: longTextField.optional(),
  attachments: zs.array(attachmentSchema).default([]),
});

export type Item = z.infer<typeof itemSchema>;
